import React ,{useRef , useEffect} from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../Navbar';
import Footer from '../Footer';

export default function FormCV6() {
    document.body.style.background = "white"

    const CVDesc = useRef()
    const loadToLocalStorage = () => {
        localStorage.setItem("CVDescription" , CVDesc.current.value);
    }

    useEffect(() => {
      
        if(localStorage.getItem("CVDescription"))
        {
            CVDesc.current.value =  localStorage.getItem("CVDescription");
        }
       
    }, [])
    

    return (
        <>
            <Navbar />
            <div style={{ fontFamily: "Questrial", marginTop: "50px", textAlign: "center" }}>
                <h2>CV Description</h2>
            </div>
            <div id='container' className="container text-center " style={{ width: "800px", marginTop: "30px", background: "white" }}>

                <div>
                    
                        <div className="mb-3">
                            <label htmlFor="DescCV" className="form-label">Describe your CV here!</label>
                            <textarea ref={CVDesc} className="form-control fs-5" placeholder='Describe your CV here' id="DescCV" rows="10" required></textarea>
                        </div>



                </div>

            </div>

            <div style={{ display: "flex", justifyContent: "center", marginTop: "80px", fontFamily: "kanit" , marginBottom:"5vh" }}>

                <Link to="/formcv5" className="btn btn-outline-danger" style={{ marginRight: "50px", width: "180px", fontSize: "18px" }}>Back</Link>


                <Link onClick={loadToLocalStorage} to="/cv01" className="btn btn-outline-success" style={{ width: "180px", fontSize: "18px" }}>Next</Link>

            </div>
            <Footer />
        </>
    )
}
